module.exports = __webpack_public_path__ + "media/images/lb/414-5f31d8523cb41953c13e4ac79e94e29d.svg";